package dev.kotlinfest._2026.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import dev.kotlinfest._2026.BrowserNotification
import dev.kotlinfest._2026.models.MyTimetable
import dev.kotlinfest._2026.models.UserSession
import dev.kotlinfest._2026.models.UserSessions
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlin.js.Date

private const val NotificationLeadTimeMillis = 5 * 60 * 1000.0
private const val NotificationCheckIntervalMillis = 30_000L

private fun UserSession.startTimeMillis(): Double = Date("2026-11-14T${time.substringBefore(" ～")}:00+09:00").getTime()

@Composable
fun SessionNotificationWatcher() {
    LaunchedEffect(Unit) {
        while (true) {
            val notificationApi = window.asDynamic().Notification
            if (MyTimetable.notificationsEnabled() && notificationApi != null && BrowserNotification.permission == "granted") {
                val now = Date.now()
                MyTimetable.read().mapNotNull(UserSessions::find).forEach { session ->
                    val startAt = session.startTimeMillis()
                    val notificationAt = startAt - NotificationLeadTimeMillis
                    val notifiedKey = "kotlinfest-2026:notified:${session.id}"
                    if (now >= notificationAt && now < startAt && window.sessionStorage.getItem(notifiedKey) == null) {
                        BrowserNotification("5分後に「${session.title}」が始まります")
                        window.sessionStorage.setItem(notifiedKey, "true")
                    }
                }
            }
            delay(NotificationCheckIntervalMillis)
        }
    }
}
